import { BASE_URL } from "../utils/BaseUrl"
import httpRequest from "../utils/httpsRequest";

export const AddAgents = async (payload) => {
  return await httpRequest(`${BASE_URL}/Agents`, "post", payload );
}

export const AgentID = async (payload) => {
  return await httpRequest(`${BASE_URL}/Agents/${payload}`, "get" );
}